import React from 'react';
import { 
  Button,
} from '@npm-registry/eapteka-ui';

import './Informer.scss';

const Informer = ({
  text,
  buttonText = 'Обновить',
  onClick,
}) => {
  return (
    <div className='BannerRecipeInformer_Root'>
      <div className='BannerRecipeInformer_Wrapper'>
        <span className='BannerRecipeInformer_Text'>
          {text}
        </span>
        {onClick && (
          <Button 
            variant='outlinedSolid'
            className='BannerRecipeInformer_Button'
            onClick={onClick}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Informer;
